import { useDispatch, useSelector } from "react-redux";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  setError,
  setExpanded,
  setVisibilty
} from "../../redux/file-upload/fileUploadSlice";
import { uploadFileSelectors } from "../../redux/file-upload/selectors";
import { uploadFiles } from "../../redux/file-upload/fileUploadThunk";
import type { AppDispatch } from "../../redux/store";
import { supportedExtensionsString2 } from "../../constans";

export const FileExtensionDialog = () => {
  const { error } = useSelector(uploadFileSelectors.selectAll);
  const isOpen = error !== null;
  const dispatch = useDispatch<AppDispatch>();

  return error ? (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsupported File Types Detected</AlertDialogTitle>
          <AlertDialogDescription>
            Some of the files selected have unsupported extensions and will not
            be uploaded. You may proceed to upload files in this supported
            format: {supportedExtensionsString2}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(setError(null));
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              dispatch(setVisibilty(true));
              dispatch(setExpanded(true));
              dispatch(uploadFiles());
              dispatch(setError(null));
            }}
          >
            Proceed
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  ) : null;
};
